<template>
	<div class="content">
		<div class="content_head">

			<select v-model="areaID" v-if="$store.state.user.UserType==0" @change="selectArea">
				<option v-for="(i,index) in $store.state.area" :value="i.areaID">{{i.areaName}}</option>
			</select>

			<select v-model="ShopID" title="选择店铺" @change="getData()" v-if="$store.state.user.UserType<=1 && $store.state.user.ShopType<=1">
				<option v-for="i in Shop" :value="i.ShopID">
					{{i.ShopName}}
				</option>
			</select>
			<select v-model="UserState" title="用户状态" @change="getData()">
				<option v-for="i in userStae" :value="i.id">
					{{i.text}}
				</option>
			</select>

		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>账号</th>
						<th>姓名</th>
						<th>类型</th>
						<th>状态</th>
						<th>登录记录</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in users">
						<td>
							{{index+1}}
						</td>
						<td>
							{{i.UserAccount}}
						</td>
						<td>
							{{i.UserName}}
						</td>
						<td>
							{{i.UserType |UserType}}
						</td>
						<td>
							{{i.UserState | UserState}}
						</td>
						<td>
							<button type="button" class="button"
								@click="$router.replace('/signInHistoryDetail'+'/'+i.UserID)"> 登录记录 </button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>

			<select v-model="pageRows" @change="changePageRows">
				<option value="10">10/页</option>
				<option value="20">20/页</option>
				<option value="30">30/页</option>

			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
		</div>
	</div>


</template>

<script>
	export default {
		name: 'users',
		data() {
			return {
				shop: [],
				userType: [],
				userStae: [{
					id: '0',
					text: '正常'
				}, {
					id: '1',
					text: '停用'
				}],
				users: '',
				Edit: '',
				getData: {},
				clear: {},
				ShopID: this.$store.state.user.ShopID,

				UserType: this.$store.state.user.UserType,

				UserState: 0,



				pageIndex: 1,
				pageRows: 20,
				count: 0
			};
		},
		created() {
			this.areaID = this.$store.state.user.areaID;
			this.ShopID = this.$store.state.user.ShopID;

			this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
			this.userType = [{
				id: 0,
				text: '管理员'
			}, {
				id: 1,
				text: '店长'
			}, {
				id: 2,
				text: '店员'
			}, {
				id: 3,
				text: '派送员'
			}];
			this.getData = function() {
				this.$request.request({
					url: 'login/getUsers',
					data: {
						pageCount: this.pageRows,
						ShopID: this.ShopID,
						UserState: this.UserState,
						pageIndex: this.pageIndex
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.users = res.users;
						this.count = res.count;
					}
				});
			}

			this.getData();

		},
		methods: {
			selectArea() {
				console.log(this.areaID)
				this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
				console.log(this.shop)
				this.count = 0;
				 
			
				if (this.Shop.length > 0) {
					this.ShopID = this.Shop[0].ShopID;
					this.pageIndex = 1;
					this.getData();
				}
			},
			changePages(s) {
				if (s == 'up') {
					if (this.pageIndex == 1)
						return;
					else
						this.pageIndex--;

				} else {
					if (this.pageIndex * this.pageRows >= this.count)
						return;
					else
						this.pageIndex++;
				}

				this.getData();
			},
			changePageRows() {
				if (this.pageIndex * this.pageRows >= this.count)
					this.pageIndex = 1;
				this.getData();
			}
		},
		computed: {
			up() {
				if (this.pageIndex == 1)
					return true;
				else
					return false;
			},
			down() {
				if (this.pageIndex * this.pageRows >= this.count)
					return true;
				else
					return false;
			},
			page() {
				if (Math.ceil((this.count / this.pageRows)) == 0)
					return this.pageIndex + '/' + 1 + '页';
				else
					return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
			}

		},
		filters: {
			UserType(v) {
				if (v == '0') return '管理员';
				if (v == '1') return '店长';
				if (v == '2') return '店员';
				if (v == '3') return '派送员';
			},
			UserState(v) {
				if (v == '0') return '正常';
				if (v == '1') return '停用';

			}
		}

	}
</script>

<style>
</style>
